import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { etherealBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Skylands / Floating Isles — a BRIGHT DAYTIME sky realm of floating islands: a pale-blue sky, a
 *  high sun + warm halo, big slow-drifting cloud bands, soft drifting light motes, gentle sun shafts,
 *  a breathing sky-bloom bed, uplifting rising motes, a faint warm shimmer, three planes of floating-
 *  island underside silhouettes receding into haze, a light airy vignette, and a cool bright grade.
 *  Airy + uplifting + vast. DISTINCT from `celestial` (a NIGHT star-sky) — this is bright daytime sky
 *  + floating land; contrast kept (no pale wash). */
export const SKYLANDS = etherealBiome({
  id: 'skylands',
  sky: { from: 0x6db4ea, to: 0xb8e0ff },
  celestial: { atX: 0.72, atY: 0.14, color: P.sunHaze, haloColor: 0xfff4cf, size: 100, haloScale: 3.2, coreAlpha: 0.9, haloAlpha: 0.22 },
  cloudBands: { count: 6, color: 0xf2f8ff, sizeMin: 420, sizeMax: 760, alphaMin: 0.05, alphaMax: 0.13, driftPxPerSec: 5, bandYMin: 0.06, bandYMax: 0.34 },
  motes: { colors: [P.sunHaze, 0xeaf6ff, P.firefly], sizeMin: 4, sizeMax: 12, driftPx: 46, periodMinMs: 6000, periodMaxMs: 13000, alphaMin: 0.14, alphaMax: 0.5 },
  rays: { color: P.sunHaze, widthMin: 70, widthMax: 160, height: 560, tiltDeg: 9, periodMinMs: 8000, periodMaxMs: 15000, alphaMin: 0.08, alphaMax: 0.3 },
  glow: {
    blobs: [
      { color: P.sunHaze, atX: 0.72, atY: 0.13, size: 460, alpha: 0.08 },
      { color: 0xbfe4ff, atX: 0.5, atY: 0.92, size: 620, alpha: 0.06 },
    ],
    breathe: { periodMs: 6500, min: 0.85, max: 1.2 },
  },
  lightField: { palette: [P.sunHaze, 0xeaf6ff, P.firefly], count: 12, sizeMin: 120, sizeMax: 300, alphaMin: 0.04, alphaMax: 0.12, driftRadius: 60, periodMinMs: 7000, periodMaxMs: 13000 },
  weather: { mode: 'rise', color: 0xfff4cf, colorEnd: 0xcfeaff,
    size: 7, frequencyMs: 120, lifespanMs: 5200, speed: 16, gravityY: -10, windX: 28, alphaEnd: 0.5,
    gust: { periodMs: 7500, min: 0.5, max: 1.4, phase: 0.3 } },
  flicker: { color: 0xfff4cf, size: 260, baseAlpha: 0.04, flickerAmp: 0.03, hzMin: 2, hzMax: 5, anchors: [{ atX: 0.25, atY: 0.88 }, { atX: 0.55, atY: 0.92 }, { atX: 0.82, atY: 0.88 }] },
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.sky.far, shape: 'peaks', color: 0xaccfe8, speed: 0.04, height: 360, alpha: 0.55, detail: 0.7, sway: { ampPx: 10, periodMs: 30000 } },
    { svg: OTHERWORLD_BACKDROPS.sky.mid, shape: 'columns', color: 0x86a9c6, speed: 0.1, height: 260, alpha: 0.74, detail: 1.0 },
    { svg: OTHERWORLD_BACKDROPS.sky.near, shape: 'peaks', color: 0x5f7e9a, speed: 0.18, height: 180, alpha: 0.9, detail: 1.1 },
  ],
  closer: {
    vignette: { color: 0x2c4a63, edgeAlpha: 0.18, washColor: 0xbfe4ff, washAlpha: 0.04 },
    grade: { top: 0xd6ecff, bottom: 0x9bc4e6, strength: 0.1, blend: 'normal' },
  },
});
